import http from "./http_v2";

export default {
  // 邮件列表
  list: params => {
    return http.get("marketcenter/email/task/list", params);
  },
  // 邮件详情
  detail: params => {
    return http.get("marketcenter/email/task/info", params);
  },
  //删除邮件
  del: params => {
    return http.post("marketcenter/email/task/delete", params);
  },
  // 发送邮件详情
  report: params => {
    return http.get("marketcenter/email/task/detail/list", params);
  },

  // 获取发件人
  fromAccount: params => {
    return http.get("marketcenter/emailmanage/current/count", params);
  },
  // 获取组织短信余额
  quota: params => {
    return http.get("marketcenter/emailmanage/count", params);
  },
  // 发送接口
  send: params => {
    return http.post("marketcenter/email/markcenter/send", params);
  },


  // 模板列表
  templateList: params => {
    return http.get("marketcenter/email/template/get/list", params);
  },
  // 模板详情
  templateDetail: params => {
    return http.get("marketcenter/email/template/get", params);
  },
  // 模板
  templateSave: params => {
    return http.post("marketcenter/email/template/save", params);
  },
  // 模板删除
  templateDel: params => {
    return http.post("marketcenter/email/template/delete", params);
  }
};
